import { ReactNode, useEffect, useRef } from 'react';
import { Footer, Header, ModalBody, ModalContainer, ModalRoot } from './styles';

import Icon from '@components/Icon';
import { CloseIcon } from '@components/Modal/styles';
import { useTheme } from 'styled-components';

interface WeModalProps {
  visible: boolean;
  onClose: () => void;
  children: ReactNode;
  backgroundColor: string;
  width: string;
  maxHeight?: string;
  maxHeightModalBody?: string;
  header?: ReactNode;
  footer?: ReactNode;
}
const WeModal = ({
  visible,
  onClose,
  children,
  maxHeight,
  maxHeightModalBody = '75vh',
  width,
  header,
  footer,
  backgroundColor,
}: WeModalProps) => {
  const theme = useTheme();
  const componentRef = useRef<HTMLInputElement | null>(null);

  const stopPropagation = (e: Pick<Event, 'stopPropagation'>) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [visible]);

  useEffect(() => {
    const element = componentRef.current;
    setInterval(() => {
      if (visible && element && element.scrollTop !== 0) {
        element.scrollTop = 0;
      }
    }, 500);
  }, [visible]);

  return (
    <ModalRoot $mounted={visible} ref={componentRef}>
      <ModalContainer
        onClick={stopPropagation}
        $backgroundColor={backgroundColor}
        $width={width}
        $maxHeight={maxHeight}
      >
        <Header>{header && <>{header}</>}</Header>
        <ModalBody maxHeightModalBody={maxHeightModalBody}>
          {children}
        </ModalBody>
        <div>{footer && <Footer>{footer}</Footer>}</div>
        <CloseIcon onClick={onClose}>
          <Icon
            size={35}
            color={theme.color.shadeGrey2}
            indentLess
            name="close"
            $hoverEffect
          />
        </CloseIcon>
      </ModalContainer>
    </ModalRoot>
  );
};

export default WeModal;
